import React from 'react';
import { YMaps } from 'react-yandex-maps';
import { ContactInfo } from './info.component';
import { Map } from './map.component';
import styles from './map.module.scss';

export const ContactMap = (): JSX.Element => {
  return (
    <div className={styles.mapContainer}>
      <YMaps query={{ apikey: process.env.yandexApiKey }}>
        <Map />
      </YMaps>
      <ContactInfo />
    </div>
  );
};
